import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'

import {GenericCTAGroupSchema} from './generic-cta-group'

export const GenericConditionalCTAsSchema = buildEntrySchemaFor('genericConditionalCtas', {
  fields: z.lazy(() =>
    z.object({
      default: GenericCTAGroupSchema,
      isLoggedIn: GenericCTAGroupSchema.optional(),
      hasCopilot: GenericCTAGroupSchema.optional(),
      hasCopilotPaid: GenericCTAGroupSchema.optional(),
      hasCopilotPro: GenericCTAGroupSchema.optional(),
      hasOrganization: GenericCTAGroupSchema.optional(),
    }),
  ),
})

export type GenericConditionalCTAs = z.infer<typeof GenericConditionalCTAsSchema>
